export const MAPBOX_STYLE = 'mapbox://styles/nestio/cj5bm415v1lmb2rmccuf77etr';
export const SENTRY_DSN = 'https://93e71708d34e48a3b5fba3c6ef63fc79@o16407.ingest.sentry.io/1462349';
